import { TaskTypeEnum } from "../../Enums/TaskTypes";
import { TaskExecutorEnum } from "../../Enums/TaskExecutors";

export type TaskContentType = {
  caption: string;
  type: TaskTypeEnum;
  executor: TaskExecutorEnum;
  isAutomaticCheck?: boolean;
  isMiniGame?: boolean;
};

/**
 * Known variables in the task content
 */
export class TaskContentDTO {
  caption: string;
  type: TaskTypeEnum;
  executor: TaskExecutorEnum;
  isAutomaticCheck: boolean = false;
  isMiniGame: boolean = false;

  constructor(taskContent: TaskContentType) {
    this.caption = taskContent.caption;
    this.type = taskContent.type;
    this.executor = taskContent.executor;
    this.isAutomaticCheck = taskContent.isAutomaticCheck ?? false;
    this.isMiniGame = taskContent.isMiniGame ?? false;
  }
}

export interface WithBackgroundDTO {
  background: string;
}

export let isTaskContentDTOWithBackground = (
  variable: TaskContentDTO
): variable is TaskContentDTO & WithBackgroundDTO => {
  return (
    isTaskContentDTO(variable) &&
    "background" in variable &&
    typeof (variable as WithBackgroundDTO).background === "string"
  );
};

export let isTaskContentDTO = (
  variable: unknown
): variable is TaskContentDTO => {
  return (
    typeof variable === "object" &&
    variable !== undefined &&
    variable !== null &&
    "type" in variable &&
    typeof variable.type === "number" &&
    "caption" in variable &&
    typeof variable.caption === "string" &&
    "executor" in variable &&
    typeof variable.executor === "number" &&
    (!("isAutomaticCheck" in variable) ||
      typeof variable.isAutomaticCheck === "boolean") &&
    (!("isMiniGame" in variable) || typeof variable.isMiniGame === "boolean")
  );
};
